export const ECHO_LOGO_URL = "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/36/f8/0c/36f80ce6-0d52-65bd-fa4e-29d11fdd51c9/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/256x256bb.jpg";

export default function EchoLogo({ size = 32, className = "", testid = "echo-logo" }) {
  return (
    <img
      src={ECHO_LOGO_URL}
      alt="Echo"
      width={size}
      height={size}
      style={{ width: size, height: size }}
      className={`rounded-[22%] object-cover ring-1 ring-white/10 shadow-[0_4px_20px_rgba(157,76,221,0.35)] ${className}`}
      data-testid={testid}
      loading="eager"
    />
  );
}
